import { render } from "./FamilyRelationshipInput.vue?vue&type=template&id=09c9a0a6"
import script from "./FamilyRelationshipInput.vue?vue&type=script&lang=js"
export * from "./FamilyRelationshipInput.vue?vue&type=script&lang=js"

import exportComponent from "/app/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__